import type { RedoCartItem } from "@redotech/merchant-sdk/rpc/schema/redo-supplies/redo-cart";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useQuery } from "@tanstack/react-query";

/** Attribute marking a cart line as a promo free item (mirrors the server). */
export const FREE_ITEM_PROMOTION_ATTRIBUTE = "suppliesPromotionId";

export function isFreeLine(item: RedoCartItem): boolean {
  return item.attributes.some((a) => a.key === FREE_ITEM_PROMOTION_ATTRIBUTE);
}

/** Cart value from paid lines only; free promo lines don't count toward the threshold. */
export function paidCartValue(items: RedoCartItem[]): number {
  return items
    .filter((item) => !isFreeLine(item))
    .reduce((sum, item) => sum + item.price * item.quantity, 0);
}

export function useActiveSuppliesPromotion() {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const { data } = useQuery({
    queryKey: ["redo-supplies-active-promotion"],
    queryFn: () => rpcClient.getActiveSuppliesPromotion({}),
  });
  return data?.promotion ?? null;
}
